
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/press-releases/[slug]",
      function () {
        return require("private-next-pages/press-releases/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/press-releases/[slug]"])
      });
    }
  